import Vue from 'vue/dist/vue.esm';
import router from './router';
import './main.scss';
import './registerServiceWorker'

window.webmech = new Vue({
  el: '#app',
  router
});
